// src/pages/TestPage/index.jsx
import React from "react";
import { CognitoIdentityProviderClient, InitiateAuthCommand } from "@aws-sdk/client-cognito-identity-provider";

const client = new CognitoIdentityProviderClient({ region: "us-east-1" });

async function loginUser() {
  const params = {
    AuthFlow: "USER_PASSWORD_AUTH",
    ClientId: "1u2969dlga5uvruimkclp63dfo",
    AuthParameters: {
      USERNAME: "ash_testGwr2026",
      PASSWORD: "Gwr2026!"
    }
  };

  const command = new InitiateAuthCommand(params);

  try {
    const response = await client.send(command);
    console.log("AuthenticationResult:", response.AuthenticationResult);
    return response.AuthenticationResult; // contains IdToken, AccessToken, RefreshToken
  } catch (err) {
    console.error("Authentication failed:", err);
    throw err;
  }
}

export default function TestPage() {
  React.useEffect(() => {
    loginUser().then(tokens => {
      // do something with tokens (like saving id token to state, local storage, etc)
      console.log("Logged in user tokens:", tokens);
    }).catch(err => {
      console.error("Login failed inside component:", err);
    });
  }, []);

  return (
    <div>
      <h1>Test Page</h1>
      <p>Check console for login output.</p>
    </div>
  );
}
